import { useMutation } from '@tanstack/react-query'
import { resendSignUpCode } from 'aws-amplify/auth'

import { sendEvent } from 'src/shared/api/events/send-event'

export const useResendConfirmationCode = () => {
  return useMutation({
    mutationFn: async (email: string) => {
      const result = await resendSignUpCode({ username: email })
      sendEvent({ eventType: 'auth_resend_code', info: { email } })
      return result
    },
    onError: (error: unknown) => {
      const errorName = error instanceof Error ? error.name : 'unknown'
      sendEvent({
        eventType: 'auth_resend_code_error',
        info: { error: errorName },
      })
    },
  })
}
